(function() {
    'use strict';

    angular
        .module('vobeApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
